import { TFunction } from 'i18next';

export interface ScriptVariables {
  'VA Name'?: string;
  'Dealership Name'?: string;
  'GM Name'?: string;
  'City/Community Name'?: string;
  'Unique Selling Point'?: string;
  'Brand/Vehicle Type'?: string;
  'Address/Location'?: string;
  'Holiday Name'?: string;
  'Sale Name'?: string;
  'Promotion Details'?: string;
  'Year/Model'?: string;
  'End Date'?: string;
  'Website URL'?: string;
  'Promotion Name'?: string;
  'Specific Offer'?: string;
  'Phone Number'?: string;
  'Convenience Feature'?: string;
  'Current Service Special'?: string;
  'Opening Time'?: string;
}

export const fillScriptVariables = (
  t: TFunction,
  scriptText: string,
  variables: ScriptVariables = {}
): string => {
  let filledText = t(scriptText);

  // Replace variables with provided values, or keep the variable name if not provided
  Object.entries(variables).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      const regex = new RegExp(`\\[${key}\\]`, 'g');
      filledText = filledText.replace(regex, value);
    }
  });

  return filledText;
};

export const AI_FLEX_VIDEO_SCRIPTS = [
  {
    id: 1,
    title: 'Immediate Lead Response',
    text: `Hi there! My name is [VA Name], and I'm part of the Customer Success Team here at [Dealership Name]. On behalf of our General Manager, [GM Name], I wanted to personally thank you for reaching out to us regarding your vehicle search. We know your time is valuable, and we appreciate the opportunity to help you find the perfect fit. I've made sure our team has your request, and one of our product specialists will be reaching out to you shortly. They will provide all the details you are looking for and answer any questions you may have. We're here to ensure you have a seamless, stress-free experience. We look forward to working with you!`,
  },
  {
    id: 2,
    title: 'Dealership Showcase',
    text: `Welcome to [Dealership Name]! Whether you're looking for a new ride or expert service, we're more than just a car lot—we're a part of the [City/Community Name] community. What sets us apart? It's our [Unique Selling Point]. From our massive inventory of [Brand/Vehicle Type] to our comfortable guest lounge, we've designed everything here with you in mind. Come experience the [Dealership Name] difference today. Stop by and see why our customers keep coming back, generation after generation. We're located at [Address/Location]—see you there!`,
  },
  {
    id: 3,
    title: 'Holiday Sale',
    text: `Happy [Holiday Name] from all of us at [Dealership Name]! To celebrate the season, we're launching our [Sale Name] event, and the savings are huge. Right now, you can get [Promotion Details] on all remaining [Year/Model] in stock! Whether you're looking to upgrade your commute or find the perfect gift for the family, now is the time to buy. These deals only last until [End Date], so don't wait! Visit us today or browse our full inventory online at [Website URL]. Let's make this [Holiday Name] one to remember!`,
  },
  {
    id: 4,
    title: 'Promotional Sale',
    text: `It's time for the [Promotion Name] at [Dealership Name], and we are clearing the lot! We need to make room for new arrivals, which means incredible deals for you. For a limited time, we're offering [Specific Offer]. Our finance team is standing by to work with all types of credit to get you behind the wheel today. Don't miss out on the [Promotion Name]—when these vehicles are gone, they're gone! Come see us at [Dealership Name] or call us at [Phone Number] to claim your deal.`,
  },
  {
    id: 5,
    title: 'Post-Sale Thank You',
    text: `Hi! I'm [VA Name], and I'm reaching out on behalf of [GM Name] and the entire team here at [Dealership Name]. We wanted to send a huge congratulations on your recent vehicle purchase! We are so excited to have you as the newest member of our dealership family. Our commitment to you doesn't end when you drive off the lot. Whether you have questions about your new features or need to schedule your first service visit, our team is always here to support you. Thank you for trusting us with your business—we're honored to have you with us. Enjoy every mile in your new ride!`,
  },
  {
    id: 6,
    title: 'Service Department Showcase',
    text: `Keep your vehicle running like new with the pros at [Dealership Name] Service. Our factory-trained technicians know your vehicle inside and out, using only genuine parts to ensure safety and performance. We know your time is valuable, which is why we offer [Convenience Feature]. Plus, don't forget to ask about our [Current Service Special]. Scheduling is easy—just visit [Website URL] or give us a call. Trust the experts at [Dealership Name] to go the extra mile for you!`,
  },
  {
    id: 7,
    title: 'After Hours Responder',
    text: `Hi there! I'm [VA Name], and I'm reaching out on behalf of the team here at [Dealership Name]. You've caught us while our showroom is currently closed for the evening, but I wanted to let you know that we've successfully received your request! We know how important your time is, so I've put your message at the top of our list for when we reopen. Our team will be back in the office at [Opening Time] and one of our specialists will reach out to you personally to provide the information you're looking for. In the meantime, feel free to browse our latest inventory or even start a trade-in appraisal right on our website at [Website URL]. Thanks for thinking of us, and we'll be in touch very soon!`,
  },
];
